import { useEffect, useState } from 'react'

// 系统自己的确认框 / 提示框，替代浏览器自带的 confirm() / alert()：
// 自带的顶上会多一行「operation.etcsvip.com.cn 显示」，样式也跟系统不一致（2026-09-30 Gavin 要求去掉）。
// 用法：if (!(await confirmBox('确认删除？'))) return      alertBox('保存成功')
// 弹窗挂在 Layout 里，切到别的页面也还在（上传视频时切走，传完照样能看到结果）
export const confirmBox = (message) => new Promise(resolve =>
  window.dispatchEvent(new CustomEvent('app-dialog', { detail: { message, resolve, confirm: true } })))
export const alertBox = (message) => new Promise(resolve =>
  window.dispatchEvent(new CustomEvent('app-dialog', { detail: { message, resolve, confirm: false } })))

export function DialogHost() {
  const [queue, setQueue] = useState([])   // 同时来多个就排队，一个一个弹
  useEffect(() => {
    const on = e => setQueue(q => [...q, e.detail])
    window.addEventListener('app-dialog', on)
    return () => window.removeEventListener('app-dialog', on)
  }, [])
  const cur = queue[0]
  useEffect(() => {
    if (!cur) return
    // 捕获阶段 + stopPropagation：弹窗开着时 Enter/Esc 只归弹窗，不能再传到底下的输入框
    //（否则工作台里光标还在输入框时按 Enter，会一边确认弹窗一边把消息发出去）
    const key = e => {
      if (e.key !== 'Escape' && e.key !== 'Enter') return
      e.preventDefault(); e.stopPropagation()
      close(e.key === 'Enter')
    }
    window.addEventListener('keydown', key, true)
    return () => window.removeEventListener('keydown', key, true)
  })
  if (!cur) return null
  function close(ok) {
    cur.resolve(cur.confirm ? ok : undefined)
    setQueue(q => q.slice(1))
  }
  return (
    <div className="modal-bg" style={{ zIndex: 300 }} onClick={e => e.target === e.currentTarget && close(false)}>
      <div className="modal" style={{ maxWidth: 380 }}>
        <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.7, fontSize: 15 }}>{cur.message}</div>
        <div className="row" style={{ justifyContent: 'flex-end', marginTop: 20 }}>
          {cur.confirm && <button className="btn" onClick={() => close(false)}>取消</button>}
          <button className="btn btn-primary" autoFocus onClick={() => close(true)}>确定</button>
        </div>
      </div>
    </div>
  )
}
